<template>
  <div class="flex h-screen">
    <SidebarProvider :default-open="defaultOpen">
      <AppSidebar />
      <Separator orientation="vertical" />
      <div class="flex flex-1 flex-col overflow-hidden">
        <AppTopbar />
        <div
          class="flex-1 overflow-y-auto overflow-x-hidden bg-muted dark:bg-background"
        >
          <slot />
        </div>
      </div>
    </SidebarProvider>
  </div>
</template>

<script setup lang="ts">
import { SIDEBAR_COOKIE_NAME } from "~/components/ui/sidebar/utils";
import AppSidebar from "../components/AppSidebar.vue";
import "@/assets/css";

const defaultOpen = useCookie<boolean>(SIDEBAR_COOKIE_NAME);
</script>
